export class CalorieDeficit {

    constructor(weight) {
        this.weight = weight
    }

    get recommendedWeeks() {
        return this.weight / 0.5
    }
}
